export default __webpack_public_path__ + "static/media/alexander-hamilton-center-paterson-11.c3df6ec9.png";